<template>
  <div class="animated fadeIn list-of-logistic_rpt">
    <b-card>
      <div slot="header">Inventory Stock Card 
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="6">
            <b-input-group >
                <b-input-group-prepend><label>Master Item</label></b-input-group-prepend>
                <b-form-input readonly v-model="filter.iteminfo" :state="!$v.filter.itemno.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuItemShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col md="4">
            <b-input-group >
                <b-input-group-prepend><label>As of Date</label></b-input-group-prepend>
                <b-form-input v-model="filter.asofdate" :state="!$v.filter.asofdate.$error" type="date" placeholder="until date"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="2">
            <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <div class="report-wraper">
          <table style="width: 100%;">
              <thead>
                  <tr>
                    <th width="90px" rowspan="2">Trx. Date</th>
                    <th  rowspan="2">Description</th>
                    <th width="150px" rowspan="2">Serial Number <br> &  Expired date</th>
                    <th width="150px" rowspan="2">Store <br> &  Rack</th>
                    <th colspan="2" style="text-align:center;">DEBIT (IN/RECEIPT) </th>
                    <th colspan="3" style="text-align:center;">CREDIT (ISSUED)</th>
                    <th  style="text-align:center;">ENDING BALANCE</th>
                    <th colspan="2" style="text-align:center;">ON TRANSFER</th>
                  </tr>
                <tr>
                    <th width="120px" style="text-align:center;">Doc. No</th>
                    <th width="100px" style="text-align:center;">Qty</th>
                    <th width="120px" style="text-align:center;">Doc. No</th>
                    <th width="120px" style="text-align:center;">Request No</th>
                    <th width="100px" style="text-align:center;">Qty</th>
                    <th width="100px" style="text-align:center;">Qty</th>
                    <th width="120px" style="text-align:center;">Doc. No</th>
                    <th width="100px" style="text-align:center;">Qty</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="row in rptLines" :key="row.tablekey" @click.stop="confirmAction()">
                    <td :class="row.kelas"><span v-if="row.tanggal"> {{row.tanggal | moment("DD MMM YYYY")}}</span></td>
                    <td :class="row.kelas">{{row.uraian}}</td>
                    <td :class="row.kelas">
                        <p v-if="row.serialNum" style="margin:0; padding:0;">{{row.serialNum}}</p>
                        <p v-if="row.expirDate" style="margin:0; padding:0;">{{row.expirDate | moment("DD MMM YYYY")}}</p>
                     </td>
                    <td :class="row.kelas">
                        <p v-if="row.namaStore" style="margin:0; padding:0;">{{row.namaStore}}</p>
                        <p v-if="row.expirDate" style="margin:0; padding:0;">{{row.shelfNo}}</p>
                     </td>
                    <td :class="row.kelas">{{row.recivDoc}}</td>
                    <td :class="row.kelas" v-if="(row.recivQty)" style="text-align:right">{{row.recivQty | numFormat('0,0.00')}} {{row.invunitom}}</td>
                    <td v-else :class="row.kelas"></td>
                    <td :class="row.kelas">{{row.issueDoc}}</td>
                    <td :class="row.kelas">{{row.requestno}}</td>
                    <td :class="row.kelas" v-if="(row.issueQty)" style="text-align:right">{{row.issueQty | numFormat('0,0.00')}} {{row.invunitom}}</td>
                    <td v-else></td>
                    <td :class="row.kelas" v-if="(row.qtyAvail)" style="text-align:right">{{row.qtyAvail | numFormat('0,0.00')}} {{row.invunitom}}</td>
                    <td v-else :class="row.kelas"></td>
                    <td :class="row.kelas">{{row.trfDoc}}</td>
                    <td :class="row.kelas" v-if="(row.trfQty)" style="text-align:right">{{row.trfQty | numFormat('0,0.00')}} {{row.invunitom}}</td>
                    <td v-else :class="row.kelas"></td>
                </tr>
              </tbody>
          </table>
      </div>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item Inventory" :centered="true">
            <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
        </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }

            td.issued {
                font-style: italic;
                background-color: rgba(0, 0, 0, 0.05) !important;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
                height: 40px;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }
        }

    }
 
</style>

<script>
import moment from 'moment';
import logistic_rpt from "../../apis/logistic_rpt";
import lkuItem from "../lookup/lkuItemLazzy";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        itemno: { required },
        // alltrx: { required },
        asofdate: { required },
    },
  }, 
  data() {
    return {
      isLoading:false,
      showReport:false,
      lkuItemShow:false,
      itemList:{},
      reportUrl: null,
      filter: {itemno:'', asofdate:moment().format('YYYY-MM-DD'), alltrx:0},
      rptLines : [],
    //   subtotal :{debit: 0, credit:0 , outstand:0}
    };
  },
  components: { Loading,lkuItem},
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },  
//   created: async function(){
//         const asofdate = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
//         // this.filter.tgl1=this.$store.state.user.tglaktif;
//         this.filter.asofdate=asofdate.format('YYYY-MM-DD');
//   },  
  methods: {
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.filter.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        this.filter.itemno = lkuData.selected.itemno;
    },
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        try {
            const result = await logistic_rpt.stockcard(this.filter);   
            this.rptLines = result[0];   
            // this.subtotal = result.data[2];
            
        } catch (error) {
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
        this.isLoading=false;      
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await logistic_rpt.stockcardexport(this.filter);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
